"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isManualProduct = void 0;
const mxp_schemas_1 = require("mxp-schemas");
const isManualProduct = (cartItem) => {
    const isProductNonStore = mxp_schemas_1.Product.ProductType.NON_STORE === cartItem.productDetails.productType;
    const isProductOnSite = mxp_schemas_1.Product.ProductType.ONSITE === cartItem.productDetails.productType;
    return isProductNonStore || isProductOnSite;
};
exports.isManualProduct = isManualProduct;
//# sourceMappingURL=isManualProduct.js.map